import { useState } from 'react';
import moment from 'moment';
import { useDocumentParams, useEditorSearch } from 'app/router/params';
import { UserCircle } from 'app/components';
import { useDocumentChanges, useApproveRevisions } from 'entities/document';

interface DocumentChange {
  revisions: { revisionId: string }[];
  user: { firstName: string; lastName: string; [key: string]: unknown };
  endDate?: string;
  [key: string]: unknown;
}

const getLastRevision = (change?: DocumentChange) => {
  if (!change) {
    return '';
  }
  return change.revisions[change.revisions.length - 1].revisionId;
};

interface ChangeProps {
  change: DocumentChange;
  onApprove?: () => void;
  select: (change: DocumentChange) => void;
  currentRevisionIdL?: string | null;
  currentRevisionIdR?: string | null;
}

const Change = ({ change, select, currentRevisionIdL }: ChangeProps) => {
  const { user, endDate } = change;

  const isCurrent = (change: DocumentChange, revisionId?: string | null) => {
    return getLastRevision(change) === revisionId;
  };

  return (
    <div className={`change ${isCurrent(change, currentRevisionIdL) ? 'bg-blue-200' : ''}`} onClick={() => select(change)}>
      <UserCircle user={user} />
      <div className="change--middle">
        <div className="change--middle--author--name">
          {user.firstName} {user.lastName}
        </div>
        <div className="change--middle--author--date">{moment(endDate).format('YYYY-MM-DD HH:mm')}</div>
      </div>
    </div>
  );
};

export const VersionHistory = ({ setRevisionL }: { setRevisionL: (selection: string) => void }) => {
  const { revisionL: revisionIdLeft, revisionR: revisionIdRight } = useEditorSearch();

  const { documentId } = useDocumentParams();
  const [toDate] = useState(() => new Date().toISOString());
  const { data: changes = [] } = useDocumentChanges(documentId, '1900-01-01', toDate) as { data: DocumentChange[] | undefined };
  const { mutate: approveRevisions } = useApproveRevisions() as { mutate: (revisionIds: string[]) => void };

  const handleApprove = (revisions: { revisionId: string }[]) => {
    approveRevisions(revisions.map((revision) => revision.revisionId));
  };

  const handleSelectChange = (change: DocumentChange) => {
    const selection = getLastRevision(change);
    setRevisionL(selection);
  };

  return (
    <div>
      <div className="sidebar-top">
        <div className="sidebar-top-item">Versionshistorik</div>
      </div>
      <div className="changes">
        {changes.map((change) => (
          <Change
            key={change.revisions[0].revisionId}
            change={change}
            onApprove={() => handleApprove(change.revisions)}
            select={handleSelectChange}
            currentRevisionIdL={revisionIdLeft}
            currentRevisionIdR={revisionIdRight}
          />
        ))}
      </div>
    </div>
  );
};
